import React from 'react'
import NextStep from './NextStep'
import SuccessPage from '../Components/SuccessPage'
import MoneyInput from '../Components/MoneyInput'
import BankSelect from '../Components/BankSelect'
import SubmitBtn from '../Components/SubmitBtn'
import AvailableMethods from '../Components/AvailableMethods'
import BQRCon from '$Deposits/Components/BQR'
import BankNone from '../Components/BankNone'

class BQR extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {


        return (
            <div className='methodsActive'>
                <BQRCon
                    BankNone={BankNone}
                    TipsView={() => {
                        return (
                            <div className='BQR_Trips'>
                                <div className='BQR_TripsBank'>
                                    <div className='BQR_TripsBank1' />
                                    <div className='BQR_TripsBank2' />
                                    <div className='BQR_TripsBank3' />
                                </div>
                                <span>Hãy quét mã QR bằng ứng dụng ngân hàng hoặc ứng dụng ví điện tử MomoPay / Viettel Pay ở bước tiếp theo</span>
                            </div>
                        )
                    }}
                    AvailableMethods={AvailableMethods}
                    MoneyInput={MoneyInput}
                    BankSelect={BankSelect}
                    SubmitBtn={SubmitBtn}
                    NextStep={NextStep}
                    SuccessPage={SuccessPage}
                />
            </div>
        );
    }
}

export default BQR



